// extracted by mini-css-extract-plugin
export default {"history":"FinanceHistory_history__QTjHK","header":"FinanceHistory_header__-WoaF","content":"FinanceHistory_content__5yYvv"};